<template>
    <div class="gallery" id="print-gallery">
        <div class="single-car-row">
            <div class="single-car-title">{{ car.company }} {{ car.model_name }} {{ car.model_year_en }}</div>
        </div>

        <div class="">
            <div class="columns is-tablet theme-columns">
                <div class="content column is-two-thirds main-image-column">
                    <figure class="image-main">
                        <img :src="mainPic"  @click="openGallery(mainPicIndex)" class="main-image">
                        <div class="prev-btn" @click="slideGallery('prev')"><i class="fas fa-chevron-left"></i></div>
                        <div class="next-btn" @click="slideGallery('next')"><i class="fas fa-chevron-right"></i></div>
                    </figure>
                </div>
                <div class="center column is-one-third main-gallery-column">
                    <div class="image-box" v-for="(image, i) in images" @mouseover="setMainPic(image, i)" @click="openGallery(i)" v-bind:key="'key'+i">
                        <div class="image-thumb">
                            <img :src="image" />
                        </div>
                    </div>
                    <gallery :isOpen="isOpen" :items="items" :options="options" @close="closeGallery"></gallery>
                </div>
            </div>
        </div>
        <p class="card-footer-item">
            <button class="button is-theme-primary" :class="{'is-loading' : isLoading }" @click="downloadZip">Download all media files.</button>
        </p>
    </div>
</template>

<script>
    import Gallery from './../../Auctions/Advance/Result/Gallery'
    export default {
        props: ['car'],
        components: {
            Gallery
        },
        data () {
            return {
                images: this.car.media.photos,
                index: null,
                mainPic: this.car.media.photos[1],
                mainPicIndex: 1
            }
        },
        methods: {
            setMainPic(img, index) {
                this.mainPic = img
                this.mainPicIndex = index
            },
            closeGallery() {
                this.$store.dispatch('setResultGalleryStatus', false)
            },
            openGallery(index) {
                this.$store.dispatch('setCarGalleryItems', this.car.media.photos)
                this.$store.dispatch('setResultGalleryOptions', { index: index })
                this.$store.dispatch('setResultGalleryStatus', true)
            },
            downloadZip() {
                this.$store.dispatch('downloadAllCarMediaFiles', this.car.id)
            },
            slideGallery(slideType) {
                if(slideType == 'prev'){
                    var prevIndex = this.mainPicIndex - 1 >= 0 ? this.mainPicIndex - 1 : 0;
                    return this.setMainPic(this.car.media.photos[prevIndex], prevIndex)
                }else{
                    var nextIndex = this.mainPicIndex + 1 < this.car.media.photos.length ? this.mainPicIndex + 1 : this.car.media.photos.length - 1;
                    return this.setMainPic(this.car.media.photos[nextIndex], nextIndex);
                }
            }
        },
        computed: {
            isLoading() {
                return this.$store.getters.getNewCarLoadingStatus
            },
            items() {
                return this.$store.getters.getResultGalleryItems
            },
            options() {
                return this.$store.getters.getResultGalleryOptions
            },
            isOpen() {
                return this.$store.getters.getResultGalleryStatus
            },
        }
    }
</script>

<style scoped>
    .image-main img {
        min-width: 100%;
    }
    .image-main {
        width: 100%;
        margin: 0;
        display: flex;
        align-items: flex-start;
        cursor: pointer;
        overflow: hidden;
    }
    .image-main img {
        min-width: 100%;
    }
    .image-main:hover {
        filter: brightness(95%);
    }
    .image-box {
        border: 1px solid white;
        width: 23%;
        margin: 0 1%;
        height: 70px;
        display: inline-block;
        background: lightgrey;
        overflow: hidden;
        border-radius: 4px;
    }
    .image-thumb {
        display: flex;
        height: 100%;
        align-items: center;
        cursor: pointer;
    }
    .image-thumb:hover {
        filter: brightness(95%);
    }
    @media (max-width:767px){
        .image-main {
            height: auto;
        }
        .content:not(:last-child) {
            margin-bottom: 0;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Cars/Car/GalleryBox.vue